import React, {useState} from "react";
import arrowLeft from "../../assets/icon/arrows/arrow-left.svg";
import arrowRight from "../../assets/icon/arrows/arrow-right.svg";

import NavItem from "./NavItem";
import navigationConfig from "./menus";

const Nav = ({ breadcrumbItems }) => {
  const [navBoxIsOpen, setNavBoxIsOpen] = useState(true);
  const [openStates, setOpenStates] = useState({});
  const handleSetOpen = (categoryName, isOpen) => {
    setOpenStates((prevState) => ({
      ...prevState,
      [categoryName]: isOpen,
    }));
  };
  const handleClickArrowNavBoxIcon = () => {
    setNavBoxIsOpen(false);
  };

  return (
    <nav className={`nav w-[16%] bg-storm-light relative ${!navBoxIsOpen && " w-[6%]"}`}>
      <div
        className={`p-6 gap-4 flex items-center ${
          !navBoxIsOpen ? "justify-center" : "justify-between"
        }`}
      >
        {navBoxIsOpen && (
          <h2 className=" text-xl font-normal text-sky-80 font-[sunflower] ">
            Trade Assistant
          </h2>
        )}
        <i
          onClick={() => {
            handleClickArrowNavBoxIcon();
            setNavBoxIsOpen(!navBoxIsOpen);
          }}
        >
          <img src={navBoxIsOpen ? arrowLeft : arrowRight} alt="" />
        </i>
      </div>
      <ul>
        {navigationConfig.map((item) => (
          <NavItem
            key={item.mainMenu.id}
            navBoxIsOpen={navBoxIsOpen}
            isOpen={openStates[item.mainMenu.title] || false}
            setIsOpen={(isOpen) => handleSetOpen(item.mainMenu.title, isOpen)}
            breadcrumbItems={breadcrumbItems}
            navItem={item}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Nav;
